import { useState } from "react";

const submitAddr = "https://readdy.ai/api/form/dagjlb3ep053ijub2bi0";

const footLinks = [
  { group: "看瓜入口", items: ["实时快讯", "今日更新", "吃瓜热榜", "围观讨论区"] },
  { group: "站内说明", items: ["关于我们", "信源与规范", "核验分级", "投稿线索"] },
  { group: "找我们", items: ["联系编辑", "商务合作", "删除申诉", "版权声明"] },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [formError, setFormError] = useState("");
  const [formOk, setFormOk] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = (fd.get("website_alt") as string || "").trim();

    // 蜜罐命中：静默按成功处理
    if (honeypot) {
      setFormOk(true);
      setFormError("");
      return;
    }
    fd.delete("website_alt");

    try {
      const res = await fetch(submitAddr, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let code = "";
      let message = "";
      try {
        const parsed = JSON.parse(text);
        code = parsed?.code || "";
        message = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      } catch {
        code = "";
      }
      const spam = /spam/i.test(text) || /form data is spam/i.test(text);
      if (res.ok && code === "OK" && !spam) {
        setFormOk(true);
        setFormError("");
        setEmail("");
        form.reset();
      } else {
        setFormOk(false);
        setFormError(message || "订阅失败，请稍后再试或直接联系编辑。");
      }
    } catch {
      setFormOk(false);
      setFormError("网络开小差了，稍后再试一次吧。");
    }
  };

  return (
    <footer className="bg-background-100">
      {/* subscribe CTA band */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-14 md:pt-20 pb-12">
        <div className="rounded-2xl border border-background-200/70 bg-background-50 overflow-hidden relative">
          <span className="absolute -right-6 -top-8 w-40 h-40 rounded-full bg-accent-100/70 blur-2xl"></span>
          <span className="absolute -left-8 -bottom-10 w-44 h-44 rounded-full bg-primary-100/60 blur-2xl"></span>
          <div className="relative px-5 md:px-10 py-8 md:py-10 flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
            <div className="flex-1">
              <div className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-900 px-3 py-1 text-xs font-semibold">
                <i className="ri-notification-3-line"></i> 新瓜抢鲜提醒
              </div>
              <h2 className="mt-4 text-2xl md:text-3xl font-black text-foreground-950 tracking-tight">
                不想错过今晚这波瓜？
              </h2>
              <p className="mt-2 text-sm md:text-base text-foreground-600 max-w-xl">
                留下邮箱，擦边吃瓜今日更新与实时快讯，我们会挑重点第一时间推到你信箱，不灌水、可随时退订。
              </p>
            </div>

            <form
              data-readdy-form
              id="subscribe-form"
              onSubmit={handleSubmit}
              className="w-full lg:w-[420px]"
              noValidate
            >
              <div className="flex flex-col sm:flex-row gap-3">
                <div className="flex-1">
                  <input
                    type="email"
                    name="email"
                    required
                    value={email}
                    onChange={(ev) => setEmail(ev.target.value)}
                    placeholder="输入你的邮箱，订阅新瓜提醒"
                    className="w-full rounded-md border border-background-300/70 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition"
                  />
                </div>
                <button
                  type="submit"
                  className="shrink-0 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 text-background-50 px-5 py-3 text-sm font-semibold hover:bg-primary-600 transition whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-send-line"></i> 立即订阅
                </button>
              </div>

              {/* 蜜罐字段 */}
              <div className="aux-input-slot" aria-hidden="true">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" readOnly />
              </div>

              {formOk && (
                <p className="mt-3 flex items-center gap-1.5 text-sm text-primary-700 font-medium">
                  <i className="ri-checkbox-circle-line"></i> 订阅成功，新瓜提醒会送到你的邮箱。
                </p>
              )}
              {formError && (
                <p className="mt-3 flex items-center gap-1.5 text-sm text-primary-700 font-medium">
                  <i className="ri-alert-line"></i> {formError}
                </p>
              )}
              <p className="mt-2 text-xs text-foreground-400 flex items-center gap-1.5">
                <i className="ri-lock-line"></i> 只用于发送提醒，绝不外泄。
              </p>
            </form>
          </div>
        </div>
      </div>

      {/* footer main */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 pb-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 border-t border-background-200/60 pt-10">
          <div className="col-span-2 md:col-span-2">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg">
                <i className="ri-water-flash-line"></i>
              </span>
              <span className="text-xl font-black tracking-tight text-foreground-950">擦边吃瓜</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-sm">
              擦边吃瓜实时快讯同步推送，最新动态与今日更新一屏看全。看瓜请理性，讨论要克制。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-tv-2-line", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="社交入口"
                  className="w-9 h-9 rounded-md border border-background-200/70 bg-background-50 text-foreground-600 hover:text-primary-700 hover:border-primary-300 flex items-center justify-center text-lg transition whitespace-nowrap"
                >
                  <i className={ic}></i>
                </a>
              ))}
            </div>
          </div>

          {footLinks.map((g) => (
            <div key={g.group}>
              <h4 className="text-sm font-bold text-foreground-950">{g.group}</h4>
              <ul className="mt-4 space-y-2.5">
                {g.items.map((it) => (
                  <li key={it}>
                    <a href="#top" className="text-sm text-foreground-600 hover:text-primary-700 transition">
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-200/60 pt-6 text-xs text-foreground-400">
          <p>© 2026 擦边吃瓜 · 资讯内容整理与社区讨论站点</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-verified-badge-line text-accent-500"></i>
            理性吃瓜 · 尊重事实 · 注意甄别
          </p>
        </div>
      </div>
    </footer>
  );
}